import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import type { FileRouteContext } from '@jotta/types/schemas/FileRouteSchema'
import { Onboarding } from '@jotta/ui/Onboarding'
import type { ReactNode } from 'react'
import type { NavLinkProps } from 'react-router-dom'
import { fileRouteContextConfig } from '../FileRoute/fileRouteContextConfig'
import type { FileRouteLinkProps } from '../FileRouteLink/FileRouteLink'
import { FileRouteNavLink } from '../FileRouteLink/FileRouteLink'

export type FileNavLinkProps = {
  children?: ReactNode
  context: FileRouteContext
} & Omit<FileRouteLinkProps<NavLinkProps>, 'children'>

export function FileNavLink({ context, children, ...props }: FileNavLinkProps) {
  const link = fileRouteContextConfig[context]

  return (
    <FileRouteNavLink context={context} path="/" {...props}>
      <PlainBrandIcon icon={link.icon} />
      <span>{link.text}</span>
      {children}
      <Onboarding task={link.onboarding} />
    </FileRouteNavLink>
  )
}
